export default __webpack_public_path__ + "static/iPad-Mockup4-6cbabc787cdf6d343b1836f0e2784286.png";